import { css } from "@emotion/react";
import { theme } from "styles/theme";

export const HeaderMobileStyle = {
  wrapper: css`
    display: flex;
    align-items: center;
    justify-content: center;

    span {
      color: ${theme.colors.white};
      font-size: 20px;
      font-style: normal;
      font-weight: 700;
      line-height: 52px;
    }
  `,

  content: css`
    background: ${theme.colors.orange[200]};
    border-radius: 4px;

    position: relative;
    width: calc(100vw - 40px);
    height: 52px;
    margin: 0 auto 10px;
    text-align: center;
    font-size: 1.25rem;
    line-height: 52px;
    font-weight: 700;
    border-radius: 0.375rem;
  `,

  btn: css`
    position: absolute;
    top: 3.5px;
    right: 0.5rem;
    z-index: 1;
    font-size: 1.5rem;
    line-height: 52px;
  `,
};
